import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import classnames from 'classnames';
import ContentItemStyles from './ContentItem.styles';
import { AppContext } from '../../../AppProvider';

const getHazMatClass = (hazMatClasses, hazMatClassId) => {
  if (!hazMatClassId) {
    return null;
  }
  const hazMatClass = hazMatClasses.find(
    hazMatClass => hazMatClass.value === hazMatClassId
  );
  if (hazMatClass) {
    return hazMatClass.title;
  }
  return null;
};

const getHazMatPackingGroup = (hazMatPackingGroups, hazMatPackingGroupId) => {
  if (!hazMatPackingGroupId) {
    return null;
  }
  const hazMatPackingGroup = hazMatPackingGroups.find(
    hazMatPackingGroup => hazMatPackingGroup.value === hazMatPackingGroupId
  );
  if (hazMatPackingGroup) {
    return hazMatPackingGroup.title;
  }
  return null;
};

class ProductItem extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    productTitle: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    klass: PropTypes.string,
    description: PropTypes.string.isRequired,
    nmfc: PropTypes.string,
    weight: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hazMat: PropTypes.object
  };

  render() {
    const {
      classes,
      name,
      productTitle,
      sku,
      klass,
      description,
      nmfc,
      weight,
      value,
      quantity,
      isHazMat,
      hazMat,
      t
    } = this.props;

    const {
      referenceData: { hazMatClasses, hazMatPackingGroups }
    } = this.context.globalProps;

    return (
      <div className={classes.root}>
        <p className={classnames(classes.detail, classes.name)}>
          {productTitle}
        </p>
        <p className={classnames(classes.detail)}>
          <strong>{`${t('SKU')}: `}</strong>
          {sku || '--'}
        </p>
        <p className={classnames(classes.detail)}>
          <strong>{`${t('Name')}: `}</strong>
          {name}
        </p>
        {!!klass && (
          <p className={classnames(classes.detail)}>
            <strong>{`${t('Class')}: `}</strong>
            {klass}
          </p>
        )}
        {!!description && (
          <p className={classnames(classes.detail)}>
            <strong>{`${t('Description')}: `}</strong>
            {description}
          </p>
        )}
        {!!nmfc && (
          <p className={classnames(classes.detail)}>
            <strong>{`${t('NMFC')}: `}</strong>
            {nmfc}
          </p>
        )}
        {!!weight && (
          <p className={classnames(classes.detail)}>
            <strong>{`${t('Weight')}: `}</strong>
            {weight}
          </p>
        )}
        {!!value && (
          <p className={classnames(classes.detail)}>
            <strong>{`${t('Value')}: `}</strong>
            {value}
          </p>
        )}
        {!!quantity && (
          <p className={classnames(classes.detail)}>
            <strong>{`${t('Quantity')}: `}</strong>
            {quantity}
          </p>
        )}
        <p className={classnames(classes.detail, classes.moreDetails)}>
          <strong>{`${t('HazMat')}: `}</strong>
          {isHazMat ? 'YES' : 'NO'}
        </p>
        {isHazMat && (
          <Fragment>
            {!!hazMat.properShippingName && (
              <p className={classnames(classes.detail)}>
                <strong>{`${t('Proper Shipping Name')}: `}</strong>
                {hazMat.properShippingName}
              </p>
            )}
            {!!hazMat.hazMatClassId && (
              <p className={classnames(classes.detail)}>
                <strong>{`${t('HazMat')} ${t('Class')}: `}</strong>
                {getHazMatClass(hazMatClasses, hazMat.hazMatClassId)}
              </p>
            )}
            <p className={classnames(classes.detail)}>
              <strong>{`${t('UN/NA')}: `}</strong>
              {hazMat.unNumber || 'NA'}
            </p>
            {!!hazMat.hazMatPackingGroupId && (
              <p className={classnames(classes.detail)}>
                <strong>{`${t('Packing Group')}: `}</strong>
                {getHazMatPackingGroup(
                  hazMatPackingGroups,
                  hazMat.hazMatPackingGroupId
                )}
              </p>
            )}
            {!!hazMat.contactName && (
              <p className={classnames(classes.detail)}>
                <strong>{`${t('Contact Name')}: `}</strong>
                {hazMat.contactName}
              </p>
            )}
            {!!hazMat.contactPhone && (
              <p className={classnames(classes.detail)}>
                <strong>{`${t('Contact Phone')}: `}</strong>
                {hazMat.contactPhone}
              </p>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

ProductItem.contextType = AppContext;
export { ProductItem };
const translatedProductItem = withNamespaces()(ProductItem);
export default withStyles(ContentItemStyles)(translatedProductItem);
